
/**
 *
 * @param arr return a sum of all numbers in an array
 * @returns
 */
export const sumArray = (arr: number[], precision = 2) => {
  if (!arr || !Array.isArray(arr)) {
    return 0;
  }

  return arr?.reduce((a, b) => Number(Number(a + b).toFixed(precision)), 0);
};

/**
 *
 * @param a number 1
 * @param b number 2
 * @returns
 */
export function GCF(a: number, b: number): number {
  if (Number(b) === 0) {
    return a;
  }

  return GCF(b, a % b);
}

export const getGreatestCommonDivisorFromArray = (arr: number[]): number => {
  const gcd = (a: number, b: number): number => b ? gcd(b, a % b) : a;

  return arr.reduce((a, b) => gcd(a, b));
};

export const fixFloatingPoint = (num: number, precision = 2) => Number.parseFloat(num.toFixed(precision));
export const convertStringToNumber = (str: string) => Number(removeCommas(str));

export const removeCommas = (str: string) => str && str.replace ? str?.replace(/,/g, '') : str;
